module.exports = __webpack_public_path__ + "img/ht_icon_clock.55b4c9bf.svg";